import { BugReportButton } from './BugReportButton';
import { SentryFeedbackWidget } from './SentryFeedbackWidget';
import { useBugReportWidget } from './useBugReportWidget';

export function BugReportWidget() {
  const variant = useBugReportWidget();

  if (variant === 'custom') {
    return <BugReportButton />;
  }

  if (variant === 'sentry') {
    return <SentryFeedbackWidget />;
  }

  return null;
}
